import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './address-book.routes';
import { AddressBookComponent } from './address-book.component';
import { AddressBookService } from './address-book.service';
import { BrowserModule } from '@angular/platform-browser';
import { AppService } from '../app.service';
import { CompanyItemComponent } from './company-item.component';
import { CompanyContactComponent } from './company-contact.component';
import { SharedModule } from '../shared/shared.module';
import { AssetManagerModule } from '../shared/asset-manager.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    AddressBookComponent,
    CompanyItemComponent,
    CompanyContactComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule.forChild(routes),
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
  ],
  providers: [
    AddressBookService
  ]
})
export class AddressBookModule {
  public static routes = routes;
}
